import { z } from "zod";
import { connectionClientSchema } from "./api-keys.js";
import { reachInputSchema } from "./connections.js";
/**
 * "Sign in with Crux" (DESIGN.md "Sign in with Crux", 2026-10-11): the consent
 * screen an app sends a person to. The Rust API answers in these shapes
 * (`server/crates/api/src/modules/oauth`): `GET /api/oauth/authorize` with the
 * app's own query string, and `POST /api/oauth/authorize` with the decision.
 */
/** What the app asked for, as its query string named it, sent back whole. */
export const oauthAskSchema = z.object({
    clientId: z.string().min(1).max(2048),
    redirectUri: z.string().min(1).max(2048),
    responseType: z.string().max(2048),
    codeChallenge: z.string().max(2048),
    codeChallengeMethod: z.string().max(2048),
    state: z.string().max(2048).optional(),
    resource: z.string().max(2048).optional(),
});
/** The app, as the consent screen introduces it. */
export const oauthClientViewSchema = z.object({
    name: z.string(),
    app: connectionClientSchema,
    /** Where it sends the person back, so they can see who is asking. */
    redirectHost: z.string(),
});
export const oauthConsentSchema = z.discriminatedUnion("kind", [
    z.object({ kind: z.literal("consent"), client: oauthClientViewSchema }),
    /** A bad ask from a known app: the person goes straight back with the error. */
    z.object({ kind: z.literal("sendBack"), redirectTo: z.string() }),
]);
export const oauthDecisionSchema = z.discriminatedUnion("kind", [
    z.object({ kind: z.literal("deny") }),
    /** Every workspace the app may reach, each as far as the person chose. */
    z.object({
        kind: z.literal("allow"),
        name: z.string().trim().min(1).max(80),
        reaches: z.array(reachInputSchema).min(1).max(50),
    }),
]);
/** Where the browser goes once the person has decided. */
export const oauthDecidedSchema = z.object({ redirectTo: z.string() });
//# sourceMappingURL=oauth.js.map